const orderStatus = [
  {
    id: 1,
    status: 'Placed',
    orderName: 'Order Placed',
    desc: "You have under 90 mins to decide what you're cooking!",
    statusEnabled: 'enabled',
    statusType: 'normal',
  },
  {
    id: 2,
    status: 'Acknowledged',
    orderName: 'Order Packed',
    desc: 'Sit back and relax while we deliver your freshly cut order to your door.',
    statusEnabled: 'enabled',
    statusType: 'normal',
  },
  {
    id: 3,
    status: 'TRIP START',
    orderName: 'Out for delivery',
    desc: 'Your order has been picked up and is on the way.',
    statusEnabled: 'enabled',
    statusType: 'normal',
  },
  {
    id: 4,
    status: 'Hold',
    orderName: 'Attempted Delivery',
    desc: 'We were at your location but could not reach you.',
    desc2: 'We will try calling you again',
    statusEnabled: 'enabled',
    statusType: 'alert',
  },
  {
    id: 5,
    status: 'Completed',
    orderName: 'Delivered',
    desc: 'Let the feast begin! We look forward to delighting you soon again!',
    statusEnabled: 'enabled',
    statusType: 'normal',
  },
];

export default orderStatus;
